import { QueryResult } from "react-query";
import { APIError } from "../../api";
import { formatAPIErrorForView } from "../formatError";

const isEmpty = (value: any) =>
  !value || (typeof value.length !== "undefined" && value.length === 0);

const noop = (...args: any) => null;

interface Forks<T> {
  error?: (error: string, ...rest: any) => JSX.Element;
  data: (data: T, ...rest: any) => JSX.Element;
  loading?: (...rest: any) => JSX.Element;
  empty?: (...rest: any) => JSX.Element;
}

/**
 * A function which accepts a result and runs a given function based on the state of the result.
 */
export function forkResult<T>(
  { error = noop, data = noop, empty = noop, loading = noop }: Forks<T>,
  resultType: QueryResult<T, APIError>,
  ...rest: any
) {
  switch (resultType.status) {
    case "success": {
      if (isEmpty(resultType.data)) {
        return empty(...rest);
      }

      return data(resultType.data as T, ...rest);
    }
    case "error": {
      return error(formatAPIErrorForView(resultType.error), ...rest);
    }
    case "loading": {
      return loading(...rest);
    }
    default:
      return null;
  }
}
